import type { ScopedPortalItem } from 'components/MapPage/CorporateViewTabs/LayersTab/arcgis-integration/arcGisPortal';
import { useDefaultLayers } from './arcgis-integration/useDefaultLayers';
import {
  PortalItemRow,
  SelectablePortalItemsList,
} from './SelectablePortalItemsList';

type AddDefaultLayerProps = {
  selectedItemIds: Set<string>;
  onToggleItem: (item: ScopedPortalItem, checked: boolean) => void;
  onToggleAllItems: (items: ScopedPortalItem[], checked: boolean) => void;
};

export function AddDefaultLayer({
  selectedItemIds,
  onToggleItem,
  onToggleAllItems,
}: AddDefaultLayerProps) {
  const { data = [] } = useDefaultLayers();

  return (
    <SelectablePortalItemsList
      items={data}
      selectedItemIds={selectedItemIds}
      onToggleAllItems={onToggleAllItems}
    >
      {(filteredItems) => (
        <div className="table-responsive">
          <table className="table table-sm align-middle mb-0">
            <thead>
              <tr>
                <th className="ps-0">Title</th>
                <th className="ps-0">Preview</th>
              </tr>
            </thead>
            <tbody>
              {filteredItems.map((item, index) => (
                <tr key={item.id ?? `default-item-${index}`}>
                  <PortalItemRow
                    item={item}
                    selectedItemIds={selectedItemIds}
                    onToggleItem={onToggleItem}
                  />
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </SelectablePortalItemsList>
  );
}
